<template>
  <div class="container">
    <div class="row center-content">
      <div class="col-sm-3 datepicker-container">
        <date-picker
          :date="selectedDate"
          :option="datePickerOptions"
          :limit="disabledDates"
          placeholder="Seleccione un dia"
          @input="handleDateChange"
        ></date-picker>
      </div>
      <div class="col-sm-3">
        <select-c name="ducto" id="ducto" placeholder="DUCTO" 
        :options="ductos" v-model="selectedDucto" @onSelectedValue="onSelectedValue" 
        passSelectedValue="true"></select-c>
      </div>
      <div class="col-sm-5 buttons-container">
        <button id="buscar-btn" class="btn btn-default waves-effect waves-light" @click="fetchPdf"
          :class="[(selectedDate === null || selectedDucto === null) ? 'disabled' : '']">
          Buscar
        </button>
        <button class="btn btn-default waves-effect waves-light" @click="printPdf"
          :class="[pdfUrl === '' ? 'disabled' : '']">Imprimir</button>
        <button class="btn btn-default waves-effect waves-light" @click="savePdf"
          :class="[pdfUrl === '' ? 'disabled' : '']">Guardar</button>
      </div>
    </div>
    <div class="row" v-if="loading">
      <div class="col-md-12 text-center">
        <p>Cargando... por favor espere</p>
        <p>Esto puede tardar unos minutos</p>
        <i class="custom-loading-color fa fa-spinner fa-spin fa-4x fa-fw"></i>
      </div>
    </div>
    <div class="row pdf-container" v-if="pdfUrl">
      <div class="iframe-container">
        <iframe :src="pdfUrl" width="100%" height="100%"></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import datePicker from 'vue-datepicker/vue-datepicker-es6.vue'
import SelectC from 'reusable/Select';
import axios from 'axios';
import toastr from 'toastr'

export default {
  components: {
    datePicker,
    SelectC
  },
  data() {
    return {
      selectedDate: {
        showInfo: {
          hour: false
        },
        startTime: {
          time: ''
        },
      },
      selectedDucto: null,
      ductos: [],
      pdfUrl: '',
      pdfData: null,
      loading: false, 
      disabledDates: [{
        type: 'fromto',
        to: this.getPreviousDay(),
      }],
      datePickerOptions: {
        type: 'day',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: 'Seleccione un dia',
        inputStyle: {
          'padding-top': '14px',
          'border-bottom': '2px solid #aaa',
          'color': 'black',
        },
        color: {
          header: 'var(--date-picker-background-color)',
          headerText: '#fff'
        },
        buttons: {
          ok: 'Ok',
          cancel: 'Cancelar'
        },
        dismissible: true
      }
    };
  },
  methods: {
    getPreviousDay() {
      const today = new Date();
      today.setDate(today.getDate() - 1);
      return today;
    },
    handleDateChange(date) {
      this.selectedDate = this.formatDate(date);
    },
    formatDate(date) {
      const d = new Date(date);
      const day = String(d.getDate()).padStart(2, '0');
      const month = String(d.getMonth() + 1).padStart(2, '0'); // Months are zero-based
      const year = d.getFullYear();
      return `${year}-${month}-${day}`;
    },
    fetchPdf() {
      this.loading = true;
      this.pdfUrl = ''; // Reset the PDF URL
      const date = this.selectedDate.time || this.formatDate(new Date());
      axios.get(`${process.env.API_BASE_URL}reports?date=${date}&section=${this.selectedDucto}`, {
        responseType: 'blob' // Important to get the response as a Blob
      })
        .then(response => {
          const blob = new Blob([response.data], { type: 'application/pdf' });
          this.pdfUrl = URL.createObjectURL(blob);
          this.pdfData = blob; // Store the blob for download
          this.loading = false;
        })
        .catch(error => {
          toastr.error('No se encontró información');
          this.loading = false;
        });
    },
    printPdf() {
      const iframe = document.querySelector('iframe');
      if (iframe) {
        iframe.contentWindow.print();
      }
    },
    savePdf() {
      if (this.pdfData) {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(this.pdfData);
        link.download = `report_${this.selectedDate}_${this.selectedDucto}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href); // Clean up the object URL
      } else {
        toastr.error('No se encontró información')
      }
    },
    onSelectedValue(value) {
      this.selectedDucto = value;
    }
  },
  mounted() {
    this.$store.dispatch('LOAD_OPS')
      .then(resp => {
        this.ductos = this.$store.getters.GET_OP({
          filteredBy: 'section_name'
        })
      })
      .catch(err => {
        console.log('Error', err)
      })
  }
};
</script>

<style scoped>
.container {
  margin-top: 20px;
  height: 100vh; /* Ensure the container takes the full viewport height */
}
.text-center {
  text-align: center;
}

.center-content {
  display: flex;
  justify-content: center;
  align-items: center;
}

.pdf-container {
  height: 100%;
}

.iframe-container {
  height: 100%;
}

iframe {
  width: 100%;
  height: 100%; /* Make the iframe fill the height of its container */
}

.datepicker-container ::placeholder {
  color: black;
}

/* Remove styles for textarea.materialize-textarea[readonly="readonly"] */
textarea.materialize-textarea[readonly="readonly"] {
  all: unset; /* Unset all styles */
}

.buttons-container {
  display: flex;
  justify-content: space-between;
}

.buttons-container .btn {
  flex: 1;
  margin: 0 5px;
}

</style>



// WEBPACK FOOTER //
// PressureReport.vue?04e5d770